module.exports = __webpack_public_path__ + "static/media/bullhorn.697c00bd.svg";